import { useEffect } from "react"

import { isNull, size } from "lodash-es"
import moment from "moment"
import { useRecoilState, useRecoilValue } from "recoil"

import {
  getSuggestedBuddiesLastFetch,
  getSuggestedBuddiesSelector,
  requestedSuggestedBuddiesAtom,
  suggestedBuddiesAtom,
} from "@fuse/recoil/buddies"

import { fetchSuggestedBuddies } from "@api/firebaseWrappedApis"

import { parseDateWithFallback } from "@fuse/utils/dates"

const useFetchSuggestedBuddies = () => {
  const [, setSuggestedBuddiesAtom] = useRecoilState(suggestedBuddiesAtom)
  const getSuggestedBuddies = useRecoilValue(getSuggestedBuddiesSelector)
  const suggestedBuddiesLastFetch = useRecoilValue(getSuggestedBuddiesLastFetch)
  const getRequestedSuggestedBuddies = useRecoilValue(
    requestedSuggestedBuddiesAtom,
  )
  const requestedSuggestedBuddiesCount = size(getRequestedSuggestedBuddies)

  useEffect(() => {
    if (!isNull(suggestedBuddiesLastFetch)) {
      const duration = moment(new Date()).diff(
        suggestedBuddiesLastFetch,
        "minutes",
      )

      if (duration >= 5) {
        fetchSuggestedBuddies({}).then((data) => {
          setSuggestedBuddiesAtom({
            loading: false,
            data: Array.isArray(data) ? data : [],
            lastFetchTime: parseDateWithFallback(new Date()),
          })
        })
      }
    } else {
      fetchSuggestedBuddies({}).then((data) => {
        setSuggestedBuddiesAtom({
          loading: false,
          data: Array.isArray(data) ? data : [],
          lastFetchTime: parseDateWithFallback(new Date()),
        })
      })
    }
  }, [suggestedBuddiesLastFetch, requestedSuggestedBuddiesCount])

  return getSuggestedBuddies
}

export default useFetchSuggestedBuddies
